import { useCallback, useMemo, useState } from "react";
import { DataTable, DataTableStateEvent } from "primereact/datatable";
import { ScreeningPscInspection, TablePageState } from "../../types/Screening";
import { pscInspectionColumns } from "../../utils/pscHelper";

type Props = {
    pscInspections: ScreeningPscInspection[];
};

export const ScreeningPSCInspectionTable = (props: Props) => {
    const { pscInspections } = props;

    const [page, setPage] = useState<TablePageState>({ row: 25, first: 0 });

    const onPage = useCallback((event: DataTableStateEvent) => {
        setPage({ row: event.rows, first: event.first });
    }, []);

    const columns = useMemo(() => pscInspectionColumns(), []);

    const rowOptions = useMemo(() => [5, 10, 25, 50], []);

    return (
        <DataTable
            value={pscInspections}
            data-cy="summary-psc-performance-table"
            scrollHeight="55vh"
            paginator
            scrollable
            stripedRows
            first={page.first}
            rows={page.row}
            rowsPerPageOptions={rowOptions}
            onPage={onPage}
            sortField="date"
            sortOrder={-1}
        >
            {columns}
        </DataTable>
    );
};
